import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import PlaceInputWrap from '../PlaceInputWrap';
import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInput';
import {errorInfoConfig} from '~/misc/error-info';
import {deleteGeosearchList} from '~/modules/geosearch/actions';
import {track} from '~/misc/metrics';
import {modalChange} from '~/modules/modal/actions';

import css from '../index.css';

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        origin: '',
        destination: '',
        fuelPrice: 3.0,
        basePrice: 2.8,
        milesPrice: 5.5,
      },
      formError: {},
    };
    this.calcHandleChange = this.calcHandleChange.bind(this);
    this.placeHandleChange = this.placeHandleChange.bind(this);
    this.placeHandleBlur = this.placeHandleBlur.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.onSubM = this.onSubM.bind(this);
  }

  componentWillUnmount() {
    this.props.deleteGeosearchList('calculator-origin');
    this.props.deleteGeosearchList('calculator-destination');
  }

  render() {
    const formData = this.state.formData;
    const formError = this.state.formError;
    return (
      <div className={css.rateContent}>
        <div className={css.inputWrap}>
          <div className={css.left}>
            < PlaceInputWrap
              id='calculator'
              onChange={(param) => this.placeHandleChange(param)}
              onBlur={(param) => this.placeHandleBlur(param)}
              formError = {this.state.formError}
            />
          </div>
          <div className={css.right}>
            <div>
              <LabeledInput
                name='fuelPrice'
                label='FUEL COST PER GALLON'
                data-qa='fuel-cost-per-gallon'
                placeholder=''
                autoComplete = 'off'
                touched={true}
                icon={'dollar'}
                iconLeft={true}
                value={formData.fuelPrice || ''}
                error={formError.fuelPrice ? formError.fuelPrice : ' '}
                onBlur={this.handleBlur}
                onChange={this.calcHandleChange}
              />
            </div>
            <div className={css.marginTop}>
              <LabeledInput
                name='basePrice'
                label='BASELINE FUEL PRICE'
                data-qa='baseline-fuel-price'
                touched={true}
                icon={'dollar'}
                autoComplete = 'off'
                iconLeft={true}
                value={formData.basePrice || ''}
                error={formError.basePrice ? formError.basePrice : ' '}
                onBlur={this.handleBlur}
                onChange={this.calcHandleChange}
              />
            </div>
            <div className={css.marginTop}>
              <LabeledInput
                name='milesPrice'
                label='Miles per gallon'
                autoComplete = 'off'
                data-qa='miles-per-gallon'
                touched={true}
                value={formData.milesPrice || ''}
                error={formError.milesPrice ? formError.milesPrice : ' '}
                onBlur={this.handleBlur}
                onChange={this.calcHandleChange}
              />
            </div>

            <div className={css.btnWrap}>
              <Button onClick={this.onSubM} mods={['huge', 'wide', 'action']}>
                Calculate
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  calcHandleChange(e) {
    const type = e.currentTarget.name;
    const value = e.currentTarget.value;
    return this.setState({
      formData: Object.assign({}, this.state.formData, {[type]: value}),
      formError: Object.assign({}, this.state.formError, {[type]: ''}),
    });
  }

  judgeInputFuelValue(obj) {
    if (Number(obj.fuelPrice) && Number(obj.basePrice) && Number(obj.fuelPrice) < Number(obj.basePrice)) {
      return true;
    }
    return false;
  }

  placeHandleChange(param) {
    this.setState({
      formData: Object.assign({}, this.state.formData, {[param.name]: param.data.placeValue}),
      formError: Object.assign({}, this.state.formError, {[param.name]: ''}),
    });
  }

  placeHandleBlur(param) {
    let errorMsg = '';
    if (!param.data.placeValue || !param.data.placeValue.name || isEmpty(param.data.placeValue)) {
      errorMsg = errorInfoConfig.placeInput.empty;
    } else if (param.data.placeValue.name.indexOf(',') === -1 && !param.data.placeValue.is_city || param.data.placeValue.is_other) {
      errorMsg = errorInfoConfig.placeInput.wrong;
    }

    this.setState({
      formData: Object.assign({}, this.state.formData, {[param.name]: param.data.placeValue}),
      formError: Object.assign({}, this.state.formError, {[param.name]: errorMsg}),
    });
  }

  handleBlur(e) {
    const type = e.currentTarget.name;
    const value = e.currentTarget.value;
    if (!value) {
      return this.setState({
        formData: Object.assign({}, this.state.formData, {[type]: ''}),
        formError: Object.assign({}, this.state.formError, {[type]: errorInfoConfig.number.empty}),
      });
    }
    if (!(/(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]+$)/.test(value))) {
      return this.setState({
        formData: Object.assign({}, this.state.formData, {[type]: ''}),
        formError: Object.assign({}, this.state.formError, {
          [type]: errorInfoConfig.number.fuleWrong,
        }),
      });
    }

    const currentData = Object.assign({}, this.state.formData, {[type]: value});
    const currentError = Object.assign({}, this.state.formError, {[type]: ''});
    const judgeInputValue = this.judgeInputFuelValue(currentData);
    if (judgeInputValue) {
      return this.setState({
        formData: Object.assign({}, currentData, {basePrice: ''}),
        formError: Object.assign({}, currentError, {
          basePrice: 'It should be smaller than Fuel Cost Per Gallon.',
        }),
      });
    }
    return this.setState({
      formData: currentData,
      formError: currentError,
    });
  }

  canClickOrNot(formData, formError) {
    let canNotClick = false;
    Object.keys(formData).forEach((key) => {
      if (key === 'origin' || key === 'destination') {
        if (isEmpty(formData[key])) {
          canNotClick = true;
          formError[key] = errorInfoConfig.placeInput.empty;
          return;
        }
        if (!formData[key].is_city) {
          canNotClick = true;
          formError[key] = errorInfoConfig.placeInput.wrong;
          return;
        }
      }
      if (!formData[key] || formError[key]) {
        canNotClick = true;
        formError[key] = formError[key] ? formError[key] : errorInfoConfig.text.empty;
        return;
      }
    });
    return {
      canNotClick,
      formError,
    };
  }

  onSubM() {
    const {accountLevel, premium} = this.props.account;
    const token = this.props.user.token;
    if (!token) {
      return this.props.login();
    }
    if (!(parseInt(accountLevel) >= parseInt(premium))) {
      return this.props.showUpgradeToPremium('caculator check page');
    }
    const formData = this.state.formData;
    const formError = this.state.formError;
    const judgeClick = this.canClickOrNot(formData, formError);
    if (judgeClick.canNotClick) {
      return this.setState({
        formError: Object.assign({}, formError, judgeClick.formError),
      });
    }
    track('calculator in my loadboard', {
      'Pick up location': formData.origin,
      'Drop off location': formData.destination,
      'Fuel cost per gallon': formData.fuelPrice,
      'baseline': formData.basePrice,
      'Miles per gallon': formData.milesPrice,
    });
    return this.props.goToRate(formData);
  }

}

export default connect(({user, routing, account}) => ({user, routing, account}), mapDispatch({
  deleteGeosearchList: (props, id) => deleteGeosearchList(id),
  showUpgradeToPremium: (props, source) => modalChange('pop', {
    source: source,
    type: 'pop_upgrade_to_premium',
  }),
}))(Calculator);



// WEBPACK FOOTER //
// ./src/components/rate/AddressAndEqipInfo/Calculator/index.js